import { pdf } from "@react-pdf/renderer";
import axios from "axios";
import { PDFDocument, rgb } from "pdf-lib";
import store from "../store/index.js";
import * as content from "content";
import PdfOfVisa from "../components/Journey/Profiles/PdfOfVisa.js";

export const uploadPDF = async () => {
  try {
    const state = store.store.getState();
    const clientData = state.Profile?.clientData || {};
    const documents = state.documents?.documents || [];
    const savedSignature = localStorage.getItem("savedSignature") || "";
    const selfiePhoto = localStorage.getItem("selfiePhoto") || "";

    const getSecureLink = async (id, index) => {
      try {
        const { data } = await axios.get(
          `${content.apiUrl}/api/v1/crm/documents/${id}/${index}`,
          {
            headers: {
              Authorization: `Bearer ${
                JSON.parse(localStorage.getItem("authUser"))?.token
              }`,
            },
          }
        );
        return data.result;
      } catch (error) {
        console.error("Error fetching secure link:", error);
        return null;
      }
    };

    const ipLinks = await Promise.all(
      documents
        .filter((doc) => doc.type === "ID")
        .map((doc, i) => getSecureLink(doc._id, i + 1))
    );

    const addressLinks = await Promise.all(
      documents
        .filter((doc) => doc.type === "ADDRESS")
        .map((doc, i) => getSecureLink(doc._id, i + 1))
    );

    // ===== PDF 1: Contract =====
    const blob = await pdf(
      <PdfOfVisa
        clientData={clientData}
        documents={documents}
        ipLinks={ipLinks}
        addressLinks={addressLinks}
        selfiePhoto={selfiePhoto}
        savedSignature={savedSignature}
      />
    ).toBlob();

    // ===== PDF 2: Agreement with signature =====
    const existingPdfBytes = await fetch("/files/agreement.pdf").then((res) =>
      res.arrayBuffer()
    );
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    // Signature placement
    if (savedSignature) {
      const imageBytes = await fetch(savedSignature).then((res) =>
        res.arrayBuffer()
      );
      const embeddedImage = await pdfDoc.embedPng(imageBytes);
      const pages = pdfDoc.getPages();

      const placements = [
        { 
          pageIndex: 13, 
          x: 330, 
          y: 450, 
          width: 150, 
          height: 100 
        },
        { 
          pageIndex: 12, 
          x: 200, 
          y: 250, 
          width: 50, 
          height: 50 
        },
      ];

      const currentDate = new Date().toLocaleDateString();

      placements.forEach(({ pageIndex, x, y, width, height }) => {
        const page = pages[pageIndex];
        if (page) {
          page.drawImage(embeddedImage, { 
            x, 
            y, 
            width, 
            height 
          });
          page.drawText(currentDate, {
            x,
            y: y - 15,
            size: 10,
            color: rgb(0, 0, 0),
          });
        }
      });
    }

    // Add documents page (Selfie, ID, Address)
    if (selfiePhoto || ipLinks[0] || addressLinks[0]) {
      const page = pdfDoc.addPage();
      const { width, height } = page.getSize();
      let currentY = height - 50;

      page.drawText("Client Verification Documents", {
        x: 50,
        y: currentY,
        size: 16,
        color: rgb(0, 0, 0),
      });
      currentY -= 40;

      // Selfie
      if (selfiePhoto) {
        try {
          const selfieBytes = await fetch(selfiePhoto).then((res) =>
            res.arrayBuffer()
          );
          const embeddedSelfie = await pdfDoc.embedJpg(selfieBytes);

          page.drawText("Client Photo:", {
            x: 50,
            y: currentY,
            size: 12,
            color: rgb(0, 0, 0),
          });
          currentY -= 20;

          page.drawImage(embeddedSelfie, {
            x: 50,
            y: currentY - 150,
            width: 200,
            height: 150,
          });

          currentY -= 150 + 40;
        } catch (error) {
          console.error("Error embedding selfie:", error);
        }
      }

      // ID + Address
      page.drawText("ID Document:", {
        x: 50,
        y: currentY,
        size: 12,
        color: rgb(0, 0, 0),
      });
      page.drawText("Proof of Address:", {
        x: 300,
        y: currentY,
        size: 12,
        color: rgb(0, 0, 0),
      });
      currentY -= 20;

      if (ipLinks[0]) {
        try {
          const ipBytes = await fetch(ipLinks[0]).then((res) =>
            res.arrayBuffer()
          );
          const embeddedIp = await pdfDoc.embedPng(ipBytes);
          page.drawImage(embeddedIp, {
            x: 50,
            y: currentY - 150,
            width: 200,
            height: 150,
          });
        } catch (error) {
          console.error("Error embedding ID:", error);
        }
      }

      if (addressLinks[0]) {
        try {
          const addressBytes = await fetch(addressLinks[0]).then((res) =>
            res.arrayBuffer()
          );
          const embeddedAddress = await pdfDoc.embedPng(addressBytes);
          page.drawImage(embeddedAddress, {
            x: 300,
            y: currentY - 150,
            width: 200,
            height: 150,
          });
        } catch (error) {
          console.error("Error embedding address:", error);
        }
      }
    }

    const modifiedPdfBytes = await pdfDoc.save();
    const pdf2Blob = new Blob([modifiedPdfBytes], {
      type: "application/pdf",
    });

    // ===== Upload to server =====
    const formData = new FormData();
    formData.append("files", blob, `${clientData.firstName}_contract.pdf`);
    formData.append("files", pdf2Blob, `${clientData.firstName}_agreement_signed.pdf`);
    formData.append("clientId", clientData._id);

    const response = await axios.post(
      `${content.apiUrl}/api/v1/cp/psp/checkout/uploadprofile`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${
            JSON.parse(localStorage.getItem("authUser"))?.token
          }`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error generating or uploading PDF:", error);
    throw error;
  }
};
